export const header = {
  headline: "Episodes",
  subHead: "Subscribe with your favorite podcatcher",
  links: [
    {
      name: "Instagram",
      href: "https://instagram.com/sixteenwomen",
      iconClass: "fa fa-instagram"
    },
    {
      name: "RSS",
      href: "https://www.sixteenwomen.com/rss",
      iconClass: "fa fa-rss"
    },
    {
      name: "Player",
      href: "https://www.sixteenwomen.com/player",
      iconClass: "fa fa-headphones"
    }
  ]
};
